<template>
    <div>
        <b-modal :id="modalSuccess.id"
                 modal-class="modal-register-success"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="img-logo-modal">
                        <img src="@/assets/img/01-register/logo-popup@3x.png">
                    </div>

                    <div class="text-title" v-html="modalSuccess.title"></div>
                    <div class="text-message">
                        {{modalSuccess.message}}
                    </div>
                </div>
                <div class="modal-base-footer pb-4">
                    <button class="btn-black" @click="clickContinue()">{{modalSuccess.strBtnOk}}</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
// import Locale from "@/helper/locale/locale.js";
import Util from '@/helper/Utility.js';

export default {
    name: "RegisterSuccess",
    props: {
        busModal: Object,
        view: String,
    },
    data: function() {
        return {
            modalSuccess: {
                id: 'register-success-',
                title: '',
                strBtnOk: '',
                message: '',
                tag: '',
            },
        };
    },
    created: function() {
        this.modalSuccess.id += this.view;
    },
    mounted: function() {
        console.log("Register Success");
        this.busModal.$on('showModal', this.showModal);
    },
    methods: {
        showModal: function(config) {

            this.modalSuccess.title = config.title;
            this.modalSuccess.message = config.message;
            this.modalSuccess.strBtnOk = Util.isEmptyStr(config.strBtnOk) ? 'Ok' : config.strBtnOk;
            this.modalSuccess.tag = config.tag;
            this.$bvModal.show(this.modalSuccess.id);
        },
        hideModal: function() {
            this.$bvModal.hide(this.modalSuccess.id);
        },
        clickContinue: function() {
            this.hideModal();
            if (this.modalSuccess.tag == "success") {
                window.location.replace("/landing/line?target_page=profile");
            }

        },
    },
}
</script>
<style lang="scss">
    @import "@/style/base/component/modal/modal.scss";

    .modal-register-success {
        @extend %modal-base;

        .modal-dialog {
            .modal-content {
                max-width: 300px;
                line-height: 1.2;
                text-align: center;

                .img-logo-modal {
                    padding-top: 20px;
                    padding-bottom: 30px;
                    img {
                        width: 150px;
                    }
                }

                .text-title {
                    font-size: 1.2rem;
                    font-weight: bold;
                }
                .text-message {
                    padding-top: 20px;
                    padding-bottom: 40px;
                }
            }
        }

    }
</style>
